import React, { useState } from 'react';
import { TextInput, Textarea, Select, Button, Group, FileInput, Notification } from '@mantine/core';
import { useForm } from '@mantine/form';
import { Upload, Check } from 'lucide-react';

export default function BlogCMS() {
  const [submitted, setSubmitted] = useState(false);

  const form = useForm({
    initialValues: {
      title: '',
      category: '',
      excerpt: '',
      content: '',
      coverImage: null,
    },
    validate: {
      title: (value) => (value.length < 5 ? 'O título deve ter pelo menos 5 caracteres' : null),
      category: (value) => (!value ? 'Selecione uma categoria' : null),
      content: (value) => (value.length < 50 ? 'O conteúdo deve ter pelo menos 50 caracteres' : null),
    },
  });

  const handleSubmit = (values) => {
    console.log('Novo artigo:', values);
    setSubmitted(true);
    form.reset();
    setTimeout(() => setSubmitted(false), 3000);
  };

  return (
    <div className="max-w-4xl mx-auto">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-navy">Blog CMS</h1>
        <p className="text-slate-500">Escreva e publique novos artigos no blog institucional.</p>
      </div>

      {submitted && (
        <Notification icon={<Check size={20} />} color="teal" title="Sucesso!" className="mb-6">
          Artigo publicado com sucesso. Ele já está disponível no site institucional.
        </Notification>
      )}

      <form onSubmit={form.onSubmit(handleSubmit)} className="bg-white p-8 rounded-2xl border border-slate-200 shadow-sm space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <TextInput
            withAsterisk
            label="Título do Artigo"
            placeholder="Ex: Novo Simples Nacional 2026"
            {...form.getInputProps('title')}
            size="md"
          />
          <Select
            withAsterisk
            label="Categoria"
            placeholder="Selecione uma categoria"
            data={[
              { value: 'tributario', label: 'Tributário' },
              { value: 'trabalhista', label: 'Trabalhista' },
              { value: 'financeiro', label: 'Financeiro' },
              { value: 'negocios', label: 'Negócios' },
            ]}
            {...form.getInputProps('category')}
            size="md"
          />
        </div>

        <FileInput
          label="Imagem de Capa"
          placeholder="Clique para enviar uma imagem"
          accept="image/png,image/jpeg"
          leftSection={<Upload size={16} />}
          {...form.getInputProps('coverImage')}
          size="md"
        />

        <Textarea
          label="Resumo (Exibido na listagem)"
          placeholder="Uma breve introdução sobre o artigo..."
          minRows={2}
          {...form.getInputProps('excerpt')}
          size="md"
        />

        <Textarea
          withAsterisk
          label="Conteúdo do Artigo"
          placeholder="Escreva seu artigo aqui..."
          minRows={10}
          {...form.getInputProps('content')}
          size="md"
        />

        <Group justify="flex-end" pt="md" className="border-t border-slate-100">
          <Button variant="outline" color="gray" type="button" onClick={() => form.reset()}>
            Cancelar
          </Button>
          <Button type="submit" color="orange">
            Publicar Artigo
          </Button>
        </Group>
      </form>
    </div>
  );
}
